import { render, staticRenderFns } from "./SupersessionTab.vue?vue&type=template&id=37a0d4ae"
import script from "./SupersessionTab.ts?vue&type=script&lang=ts&external"
export * from "./SupersessionTab.ts?vue&type=script&lang=ts&external"
import style0 from "./SupersessionTab.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports